import Vue from 'vue'
import VueI18n from 'vue-i18n'

import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui中文包
// import elementSauLocale from '@/assets/languages/el-sau'

import zhLocal from '@/assets/languages/zh_cn.json'
import enLocal from '@/assets/languages/en_us.json'
// import sauLocal from '@/assets/languages/sau.json'

import ElementLocale from 'element-ui/lib/locale'

Vue.use(VueI18n)
 
// 注册i18n实例并引入语言文件，文件格式等下解析
var lang = window.localStorage.getItem("lang")||'en_us'


const i18n = new VueI18n({
  locale: lang,
  messages: {
    'zh_cn': {
      // require('@/assets/languages/zh_cn.json'),
      ...zhLocal,
      ...elementZhLocale
    },
    'en_us': {
      // require('@/assets/languages/en_us.json'),
      ...enLocal,
      ...elementEnLocale
    }
    // ,
    // 'sau':{
    //   ...sauLocal,
    //   ...elementSauLocale
    // }
  }
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n